export class FilterDetail {
  requestStatuses: number[];
  serviceStatuses: number[];
  paymentStatuses: number[];
  serviceCategories: number[];
  services: number[];
  implementations: number[];
  fromDate?: Date;
  fromDateYear?: number;
  fromDateMonth?: number;
  fromDateDay?: number;
  toDate?: Date;
  toDateYear?: number;
  toDateMonth?: number;
  toDateDay?: number;
  fromSessionDate?: Date;
  fromSessionDateYear?: number;
  fromSessionDateMonth?: number;
  fromSessionDateDay?: number;
  toSessionDate?: Date;
  toSessionDateYear?: number;
  toSessionDateMonth?: number;
  toSessionDateDay?: number;
  fromCompleteAuditDate?: Date;
  fromCompleteAuditDateYear?: number;
  fromCompleteAuditDateMonth?: number;
  fromCompleteAuditDateDay?: number;
  toCompleteAuditDate?: Date;
  toCompleteAuditDateYear?: number;
  toCompleteAuditDateMonth?: number;
  toCompleteAuditDateDay?: number;
  isDelayedOrders: boolean;
  employeeSearch: string;
  auditorSearch: string;
  supervisorSearch: string;
  orderBySearch: string;
}
